import React, { useCallback, useState } from 'react'
import {connect, useDispatch, useSelector} from 'react-redux'
import {change, Field, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form'
import {
  FormButtons,
  renderers,
  upperCase,
  validations,
} from '../../../components'
import { GSXService } from '../../../services'
import { DeviceRepairEligibility } from './DeviceRepairEligibility'
import { DeviceActions } from './DeviceActions'
import * as ReactBootstrap from "react-bootstrap";
import {FormsConstants} from "../../../state/forms";
const skipValidation = true

const MODAL_TO_ALLOW_COUNTRY_EDIT = [
'iPhone 6S',
'iPhone 6S Plus',
'iPhone 7',
'iPhone 7 Plus',
'iPhone 8',
'iPhone 8 Plus',
'iPhone X',
'iPhone XR',
'iPhone XS',
'iPhone Xs Max',
'iPhone 11',
'iPhone 11 Pro',
'iPhone 11 Pro Max',
'iPhone 12',
'iPhone 12 Mini',
'iPhone 12 Pro',
'iPhone 12 Pro Max',
'iPhone 13',
'iPhone 13 Mini',
'iPhone 13 Pro',
'iPhone 13 Pro Max',
'iPhone 14',
'iPhone 14 Pro',
'iPhone 14 Pro Max','iPhone 14 plus','iPhone SE (2nd gen)',
'iPhone SE (3rd gen)'].map((x)=>x.toLowerCase())

export type DeviceFormProp={
    identifier?:string
    showInwardTimeField?:boolean
    productName?:string
    reservationId?:string
}
const FORM_NAME = "DEVICE_FORM"
const DeviceFormHTML : React.FC<DeviceFormProp & InjectedFormProps<{}, DeviceFormProp>> =  ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  identifier,
    productName,
  showInwardTimeField,
    reservationId,

}) => {
  const [eligibilityDetails, setEligibilityDetails] = useState(null)
  const [warningMessages, setWarningMessages] = useState([])

  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth)
  const { is_superuser } = user
   let warningMessagesTemp:Array<string> = []
  const getEligibilityInfo = useCallback((identifier:string) => {
    new GSXService()
      .repair_eligibility({
        identifier: identifier,
      })
      .then((response) => {
        setEligibilityDetails(response.eligibilityDetails)

        let repairOptions:Array<string> = []
        response.eligibilityDetails.outcome.forEach((item) => {
          const { reasons } = item
          reasons.forEach((reason) => {
            if (reason.repairOptions?.length>0) {
              repairOptions = reason.repairOptions
            }
            warningMessagesTemp.push(
              reason.messages
            )
          })

        })
          // setWarningMessages(warningMessagesTemp)

        if (repairOptions.length>0) {
          dispatch(
            change(
              FORM_NAME,
              'gsx_repair_type',
              repairOptions[0].option
            )
          )
          dispatch(
            change(
             FORM_NAME,
              'gsx_service_non_repair_type',
              repairOptions[0].subOption
            )
          )
        }
      })
      .catch((_errors) => {
        setEligibilityDetails(null)
      })

  },[identifier])
function formatDate(dateString) {
  // Parse the input date string into a Date object
  const dateObj = new Date(dateString);

  // Get the individual components of the date
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');

  // Assemble the formatted date string
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}
  const onDeviceInfo = useCallback((deviceInfo) => {
    if (deviceInfo) {
      getEligibilityInfo(deviceInfo.identifiers.serial)
      dispatch(
        change(
          FORM_NAME,
          'product_name',
          deviceInfo.productDescription
        )
      )
      dispatch(
        change(
          FORM_NAME,
          'configuration',
          deviceInfo.configDescription
        )
      )
      dispatch(
        change(
          FORM_NAME,
          'serial_number',
          deviceInfo.identifiers.serial
        )
      )


      if (deviceInfo.warrantyInfo) {
        dispatch(
          change(
            FORM_NAME,
            'gsx_service_type',
            deviceInfo.warrantyInfo.warrantyStatusDescription
          )
        )
            dispatch(
          change(
            FORM_NAME,
            'inward_gsx_service_type',
            deviceInfo.warrantyInfo.warrantyStatusDescription
          )
        )



        dispatch(
          change(
            FORM_NAME,
            'purchase_country',
            deviceInfo.warrantyInfo.purchaseCountryDesc || "Not Received From GSX"
          )
        )
                 dispatch(
        change(
          FORM_NAME,
          'purchase_date',
          formatDate(deviceInfo.warrantyInfo.purchaseDate)
        )
      )
      }

      if (deviceInfo.identifiers.imei) {
        dispatch(
          change(
            FORM_NAME,
            'alternate_device_id',
            deviceInfo.identifiers.imei
          )
        )
      } else {
        dispatch(
          change(
            FORM_NAME,
            'alternate_device_id',
            undefined
          )
        )
      }
      if (deviceInfo.identifiers.imei2) {
        dispatch(
          change(
            FORM_NAME,
            'imei2_number',
            deviceInfo.identifiers.imei2
          )
        )
      } else {
        dispatch(
          change(
            FORM_NAME,
            'imei2_number',
            undefined
          )
        )
      }
    }
  }, [dispatch, getEligibilityInfo])
  const getReservationData = () => {
    if (reservationId) {
        new GSXService().fetch_reservation_details({
            reservationId: reservationId
        }).then((res) => {
                const {product,customer} = res
                dispatch(
                    change(
                        FORM_NAME,
                        'identifier',
                        product.serialNumber
                    )
                )
              dispatch(
                    change(
                        FORM_NAME,
                        'product_name',
                        product.productDescription
                    )
                )
               dispatch(
                    change(
                        FormsConstants.formNames.CUSTOMER_FORM,
                        'first_name',
                        customer.firstName
                    )
                )
                dispatch(
                    change(
                        FormsConstants.formNames.CUSTOMER_FORM,
                        'last_name',
                        customer.lastName
                    )
                )
                dispatch(
                    change(
                        FormsConstants.formNames.CUSTOMER_FORM,
                        'email',
                        customer.emailId
                    )
                )
            dispatch(
                    change(
                        FormsConstants.formNames.CUSTOMER_FORM,
                        'contact_number',
                        customer.phone?.primaryPhone
                    )
                )
            dispatch(
                    change(
                        FormsConstants.formNames.CUSTOMER_FORM,
                        'token_number',
                        res.reservationId
                    )
                )

              dispatch(
                    change(
                        FormsConstants.formNames.ISSUE_FORM,
                        'issue_reported_by_customer',
                        product.issueReported
                    )
                )


        })
    }
  }
  return (
    <form onSubmit={handleSubmit}>
         <ReactBootstrap.Accordion >
      <ReactBootstrap.Accordion.Item eventKey="1">
        <ReactBootstrap.Accordion.Header>Add Reservation Token</ReactBootstrap.Accordion.Header>
        <ReactBootstrap.Accordion.Body>
          <Field
        name="reservationId"
        label="Reservation Id"
        component={renderers.renderField}
        normalize={upperCase}
        type="text"
      />
        {reservationId && <ReactBootstrap.Button onClick={getReservationData}>Get Reservation Data</ReactBootstrap.Button>}
        </ReactBootstrap.Accordion.Body>
      </ReactBootstrap.Accordion.Item>
         </ReactBootstrap.Accordion>



      <Field
        name="identifier"
        label="Serial Number/IMEI"
        validate={[validations.required,validations.anyThingButAsterisk]}
        component={renderers.renderField}
        normalize={upperCase}
        type="text"
      />


      {identifier && (
        <DeviceActions
          identifier={identifier}
          onDeviceInfo={onDeviceInfo}
          eligibilityDetails={eligibilityDetails}
          warningMessages={warningMessages}
        />
      )}
      {eligibilityDetails && (
        <DeviceRepairEligibility
          device_identifier={identifier}
          eligibilityDetails={eligibilityDetails}
          warningMessages={warningMessages}
        />
      )}

      <Field
        name="serial_number"
        label="Serial Number"
        disabled={true}
        validate={skipValidation ? [] : [validations.required]}
        component={renderers.renderHiddenField}
        type="text"
      />
      <Field
        name="imei2_number"
        label="IMEI2 Number"
        component={renderers.renderHiddenField}
        normalize={upperCase}
        type="text"
      />
      <Field
        name="alternate_device_id"
        label="Alternate Serial Number"
        disabled={true}
        validate={skipValidation ? [] : [validations.required]}
        component={renderers.renderHiddenField}
        type="text"
      />
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={4}>
             <Field
        name="product_name"
        label="Product Name"
        validate={[validations.required, validations.anyThingButAsterisk]}
        component={renderers.renderField}
        type="text"
      />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={4}>
              <Field
        name="configuration"
        label="Configuration"
        validate={[validations.required, validations.anyThingButAsterisk]}
        component={renderers.renderField}
        type="text"
      />
        </ReactBootstrap.Col>

          <ReactBootstrap.Col xs={4}>
              <Field
        name="model_number"
        label="Model Number"
        component={renderers.renderField}
        type="text"
      />
        </ReactBootstrap.Col>


</ReactBootstrap.Row>

   <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={4}>
      <Field
        name="gsx_coverage_type"
        label="GSX Coverage Type"
         validate={[validations.anyThingButAsterisk]}
        component={renderers.renderField}
        type="text"
      />
        </ReactBootstrap.Col>
<ReactBootstrap.Col xs={4}>
       <Field
        name="gsx_repair_type"
        label="GSX Repair Type"
         validate={[validations.anyThingButAsterisk]}
        component={renderers.renderField}
        type="text"
      />
</ReactBootstrap.Col>
<ReactBootstrap.Col xs={4}>
      <Field
        name="gsx_service_non_repair_type"
        label="GSX Service Non repair Type"
        validate={[validations.anyThingButAsterisk]}
        component={renderers.renderField}
        type="text"
      />
</ReactBootstrap.Col>
   </ReactBootstrap.Row>
   <ReactBootstrap.Row>
       <ReactBootstrap.Col xs={showInwardTimeField?6:12}>
      <Field
        name="purchase_country"
        label="Purchase Country"
        validate={[validations.required, validations.anyThingButAsterisk]}
        component={productName && MODAL_TO_ALLOW_COUNTRY_EDIT.includes(productName.toLowerCase()) && !is_superuser ?
            renderers.renderDisabledField : renderers.renderField}
        type="text"
         disabled={true}
      />
           </ReactBootstrap.Col>

         <ReactBootstrap.Col xs={showInwardTimeField?6:12}>
      <Field
        name="purchase_date"
        label="Purchase Date"
        validate={[]}
        component={renderers.renderField}
        type="text"
         disabled={true}
      />
           </ReactBootstrap.Col>

        {showInwardTimeField &&<ReactBootstrap.Col xs={6}>
          <Field
            name="inward_date_for_repair"
            label="Repair Time For GSX Repair"
            component={renderers.renderDateTimePicker}
            dateFormat="MMMM d, yyyy h:mm aa"
          />
        </ReactBootstrap.Col>}
   </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
const validateDeviceForm = (values) => {
    let errors={}
    const skipValidation = true
    if (skipValidation) return errors
  if (!values.serial_number) {
    errors.identifier = { _error: 'Get Device Warranty Info to Proceed.' }
  }

  let arr = [values.serial_number, values.alternate_device_id]
  if (values.serial_number && !arr.includes(values.identifier))
    errors.identifier = {
      _error: 'Device Warranty Info need to be re evaluated.',
    }

  return errors
}
// Decorate with redux-form
let DeviceForm = reduxForm({
  form: FORM_NAME,
  validate: validateDeviceForm,
})(DeviceFormHTML)
// Decorate with connect to read form values
const selector = formValueSelector(FORM_NAME)
DeviceForm = connect((state) => {
     // can select values individually
  const identifier = selector(state, 'identifier')
  const productName = selector(state, 'product_name')
  const reservationId = selector(state, 'reservationId')

  return {
    identifier,
    productName,
    reservationId
  }
})(DeviceForm)
export default DeviceForm
